import * as React from "react";
import { Button, Badge } from "antd";
import { Bell } from "react-feather";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { toggleDrawer, selectUnreadCount } from "../../store/notificationDrawerSlice";

export const NotificationBellButton: React.FC = () => {
  const dispatch = useAppDispatch();
  const unreadCount = useAppSelector(selectUnreadCount);

  const handleClick = () => {
    dispatch(toggleDrawer());
  };

  return (
    <Badge count={unreadCount} size="small" offset={[-4, 4]}>
      <Button type="text" onClick={handleClick} icon={<Bell size={16} />} />
    </Badge>
  );
};
